export function descargarDatosBancarios() {
  window.open(
    "https://www.adrianmercado.com.ar/files/datos-bancarios-adrian-mercado-2025-10.pdf",
    "_blank"
  );
}